@if (control?.touched) {
  @if (control?.hasError('required')) {
    {{ type === 'select'
        ? ('Foundation.SelectionRequiredValidation' | translate)
        : ('Foundation.InputRequiredValidation' | translate)
    }}
  }
  @else if (control?.hasError('invalidEmail') || control?.hasError('invalidPhoneNumber')) {
    {{ 'Foundation.InvalidInputValidation' | translate }}
  }
  @else if (control?.hasError('maxlength') && type !== 'mobileNumber') {
    {{ 'Foundation.MaxLengthValidation' | translate }}:
    {{ control?.getError('maxlength').actualLength }} / {{ control?.getError('maxlength').requiredLength }}
  }
}